module.exports = __webpack_public_path__ + "535a7ed81fdb14faeaddd21ebd576d34.MP3";